function loadArticles(loadSkip, loadTake) {
    var source = $("#article-template").html();
    var template = Handlebars.compile(source);

    $.ajax({
        type: "GET",
        url: '/api/articles/more',
        data: {
            skip: loadSkip,
            take: loadTake
        },
        success: function (data) {
            skip = skip + data.length;

            if (data.length < take)
                $(".article-list-page__show_more").hide();
            else
                $(".article-list-page__show_more").show();

            var headerHeight = ($("header").css("position") == "fixed") ? $("header").height() + 10 : 0;
            var position = $("#article-list article:last-child()").offset().top + $("#article-list article:last-child()").height() - headerHeight;
            $('html, body').stop().animate({'scrollTop': position}, 900, 'swing');

            $(data).each(function(index, item) {
                var html = template(item);
                $("#article-list").append(html);
            });

        },
        error: function (data) {
            $("#article-list").html("En feil oppstod ved henting av nyheter.");
        }
    });
}

$("#showmorebutton").click(function (e) {
    e.preventDefault();
    $("#showmorebutton").blur();
    loadArticles(skip, take);
});